import { escapeRegex } from '../utils/escapeRegex.js';
import { toSafeObject } from '../utils/toSafeObject.js';
import { toSafeString } from '../utils/toSafeString.js';

/* Runner messages name steps by id — `Code step "s3f9" is missing options.promptTemplate.` — which tells a reader
   nothing. One alternation matched on word boundaries, longest id first: boundaries stop an id matching inside a longer
   token, and alternation is leftmost-longest by branch order, so `step_a` cannot consume part of `step_a_child`. Steps
   with no resolvable name keep their id. */
const resolvePieveWorkflowStepIdsInText = ({ text, stepNameByStepId } = {}) => {
  const safeText = toSafeString(text);
  const nameByStepId = toSafeObject(stepNameByStepId);
  const stepIds = Object.keys(nameByStepId)
    .filter((stepId) => {
      return stepId && toSafeString(nameByStepId[stepId]);
    })
    .sort((left, right) => {
      return right.length - left.length;
    });

  if (!safeText || stepIds.length < 1) {
    return safeText;
  }

  return safeText.replace(new RegExp(`\\b(${stepIds.map(escapeRegex).join('|')})\\b`, 'g'), (stepId) => {
    return toSafeString(nameByStepId[stepId]);
  });
};

export default resolvePieveWorkflowStepIdsInText;
